<template>
  <div>
    <div class="chat-item chat-item--question">
      <writing-animation v-if="show.writing_1"></writing-animation>
      <transition name="fade">
        <div class="chat-item__inr" v-if="show.question_1">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              <span class="question__txt">あと3問です！あなたのお名前も教えてください！</span>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div
      class="chat-item chat-item--anser chat-item--input"
      :class="displayUserIconClass($parent.formData.sex)"
      :data-name="displayIconName($parent.formData.name_sei)"
      v-show="show.answer_1"
    >
      <transition name="fade">
        <div class="chat-item__inr">
          <div class="input--col2">
            <input type="text" id="name_sei" name="name_sei" v-model="name_sei" placeholder="姓" @input="updateKanaSei">
            <input type="text" id="name_mei" name="name_mei" v-model="name_mei" placeholder="名" @input="updateKanaMei">
          </div>
        </div>
      </transition>
    </div>
    <div
      class="chat-item chat-item--anser chat-item--input"
      :class="displayUserIconClass($parent.formData.sex)"
      :data-name="displayIconName($parent.formData.name_sei)"
      v-show="show.answer_2"
    >
      <transition name="fade">
        <div class="chat-item__inr">
          <div class="input--col2">
            <input type="text" id="kana_sei" name="kana_sei" v-model="kana_sei" placeholder="せい">
            <input type="text" id="kana_mei" name="kana_mei" v-model="kana_mei" placeholder="めい">
          </div>
        </div>
      </transition>
      <transition name="fade">
        <button
          class="chat-item--anser__button"
          type="button"
          :disabled="isDisabled.name"
          @click.once="clickFixName"
          @click="changeNameData"
        >{{ btnContent.name }}</button>
      </transition>
    </div>
    <transition name="fade">
      <div
        class="chat-item chat-item--anser"
        :class="displayUserIconClass($parent.formData.sex)"
        :data-name="displayIconName($parent.formData.name_sei)"
        v-if="show.fix_1"
      >
        <div class="chat-item__inr">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              {{ `${$parent.formData.name_sei}${$parent.formData.name_mei}（${$parent.formData.kana_sei}${$parent.formData.kana_mei}）` }}
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div class="chat-item chat-item--question" v-if="show.writing_2 || show.question_2">
      <writing-animation v-if="show.writing_2"></writing-animation>
      <transition name="fade">
        <div class="chat-item__inr" v-if="show.question_2">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              <span>{{ `${$parent.formData.name_sei}${$parent.formData.name_mei}（${$parent.formData.kana_sei}${$parent.formData.kana_mei}）` }}</span>さん、履歴書に記載用の<span class="question__txt">ご連絡先</span>をおしえてください！
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div
      class="chat-item chat-item--anser chat-item--input"
      :class="displayUserIconClass($parent.formData.sex)"
      :data-name="displayIconName($parent.formData.name_sei)"
      v-if="show.answer_3"
    >
      <transition name="fade">
        <div class="chat-item__inr">
          <div class="input--col3">
            <label class="form-label">履歴書に記載するお電話番号</label>
            <input type="text" v-model="tel1" placeholder="例）090">
            <span class="haihun">-</span>
            <input type="text" v-model="tel2" placeholder="0000">
            <span class="haihun">-</span>
            <input type="text" v-model="tel3" placeholder="0000">
          </div>
        </div>
      </transition>
    </div>
    <div
      class="chat-item chat-item--anser chat-item--input"
      :class="displayUserIconClass($parent.formData.sex)"
      :data-name="displayIconName($parent.formData.name_sei)"
      v-if="show.answer_4"
    >
      <transition name="fade">
        <div class="chat-item__inr">
          <div class="input--col1">
            <label class="form-label">履歴書に記載するメールアドレス</label>
            <input type="text" v-model="email" placeholder="aaaa@example.com">
          </div>
        </div>
      </transition>
      <transition name="fade">
        <button
          class="chat-item--anser__button"
          type="button"
          :disabled="isDisabled.telAndMail"
          @click.once="clickFixTelAndMail"
          @click="changeTelAndMailData"
        >{{ btnContent.telAndMail }}</button>
      </transition>
    </div>
    <transition name="fade">
      <div
        class="chat-item chat-item--anser"
        :class="displayUserIconClass($parent.formData.sex)"
        :data-name="displayIconName($parent.formData.name_sei)"
        v-if="show.fix_2"
      >
        <div class="chat-item__inr">
          <div class="chat-item__txt">
            <div class="chat-item__txt__inr">
              電話番号：{{ `${$parent.formData.tel1}-${$parent.formData.tel2}-${$parent.formData.tel3}` }}<br />
              メールアドレス：{{ $parent.formData.email }}
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import GenderMixin from '../../mixins/GenderMixin'
import functionsMixin from '../../mixins/functionsMixin'
import WritingAnimation from '../animations/WritingAnimation'
// import Historykana from 'historykana'
import * as AutoKana from 'vanilla-autokana'

let autoKanaSei
let autoKanaMei

export default {
  name: 'FormNameAndTelAndMail',
  mixins: [GenderMixin, functionsMixin],
  components: {
    WritingAnimation
  },
  data: function () {
    return {
      show: {
        writing_1: true,
        question_1: false,
        answer_1: false,
        answer_2: false,
        next_1: false,
        fix_1: false,
        writing_2: false,
        question_2: false,
        answer_3: false,
        answer_4: false,
        next_2: false,
        fix_2: false,
        writing_3: false,
        confirmMessage: false
      },
      isDisabled: {
        name: true,
        telAndMail: true
      },
      isFix: {
        name: false,
        telAndMail: false
      },
      btnContent: {
        name: '次へ',
        telAndMail: '次へ'
      },
      name_sei: null,
      name_mei: null,
      kana_sei: null,
      kana_mei: null,
      tel1: null,
      tel2: null,
      tel3: null,
      email: null,
      historyKanaSei: [],
      historyKanaMei: [],
      autoKana: {
        sei: undefined,
        mei: undefined
      }
    }
  },
  mounted: function () {
    setTimeout(function () {
      this.show.writing_1 = false
      this.show.question_1 = true
      this.autoScroll()
      setTimeout(function () {
        this.show.answer_1 = true
        this.show.answer_2 = true
        this.autoScroll()
      }.bind(this), 500)
    }.bind(this), 1000)
    autoKanaSei = AutoKana.bind('#name_sei', '#kana_sei')
    autoKanaMei = AutoKana.bind('#name_mei', '#kana_mei')
  },
  watch: {
    name_sei: function () {
      this.watchName()
    },
    name_mei: function () {
      this.watchName()
    },
    kana_sei: function () {
      this.watchName()
    },
    kana_mei: function () {
      this.watchName()
    },
    tel1: function (newVal, oldVal) {
      let numberReg = /^\d*$/
      if (newVal) {
        if (newVal.length > 4 || !numberReg.test(newVal)) {
          this.tel1 = oldVal
        }
      }
      this.watchTelAndMail()
    },
    tel2: function (newVal, oldVal) {
      let numberReg = /^\d*$/
      if (newVal) {
        if (newVal.length > 4 || !numberReg.test(newVal)) {
          this.tel2 = oldVal
        }
      }
      this.watchTelAndMail()
    },
    tel3: function (newVal, oldVal) {
      let numberReg = /^\d*$/
      if (newVal) {
        if (newVal.length > 4 || !numberReg.test(newVal)) {
          this.tel3 = oldVal
        }
      }
      this.watchTelAndMail()
    },
    email: function () {
      this.watchTelAndMail()
    }
  },
  methods: {
    updateKanaSei: function () {
      this.kana_sei = autoKanaSei.getFurigana()
    },
    updateKanaMei: function () {
      this.kana_mei = autoKanaMei.getFurigana()
    },
    watchName: function () {
      this.isDisabled.name = true
      if (this.name_sei && this.name_mei) {
        if (this.kana_sei && this.kana_mei) {
          this.isDisabled.name = false
          if (this.isFix.name) {
            this.btnContent.name = '更新'
          } else {
            this.btnContent.name = '次へ'
          }
        }
      }
    },
    watchTelAndMail: function () {
      this.isDisabled.telAndMail = true
      if (this.tel1 && this.tel2 && this.tel3) {
        if (this.email) {
          let mailReg = /^[A-Za-z0-9]{1}[A-Za-z0-9+_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/
          if (mailReg.test(this.email)) {
            this.isDisabled.telAndMail = false
            if (this.isFix.telAndMail) {
              this.btnContent.telAndMail = '更新'
            } else {
              this.btnContent.telAndMail = '次へ'
            }
          }
        }
      }
    },
    clickFixName: function () {
      this.show.answer_1 = false
      this.show.answer_2 = false
      this.isFix.name = true
      this.isDisabled.name = true
      this.$emit('form-fix-name', {
        name_sei: this.name_sei,
        name_mei: this.name_mei,
        kana_sei: this.kana_sei,
        kana_mei: this.kana_mei
      })
      this.show.fix_1 = true
      this.autoScroll()
      setTimeout(function () {
        this.show.writing_2 = true
        this.autoScroll()
        setTimeout(function () {
          this.show.writing_2 = false
          this.show.question_2 = true
          this.autoScroll()
          setTimeout(function () {
            this.show.answer_3 = true
            this.show.answer_4 = true
            this.autoScroll()
          }.bind(this), 500)
        }.bind(this), 1000)
      }.bind(this), 500)
    },
    clickFixTelAndMail: function () {
      this.show.answer_3 = false
      this.show.answer_4 = false
      this.isFix.telAndMail = true
      this.isDisabled.telAndMail = true
      this.$emit('form-fix-tel-and-mail', {
        tel1: this.tel1,
        tel2: this.tel2,
        tel3: this.tel3,
        email: this.email
      })
      this.show.fix_2 = true
      this.$emit('form-next')
      this.autoScroll()
    },
    changeNameData: function () {
      if (this.isFix.name) {
        this.$emit('form-change-name', {
          name_sei: this.name_sei,
          name_mei: this.name_mei,
          kana_sei: this.kana_sei,
          kana_mei: this.kana_mei
        })
        this.isDisabled.name = true
      }
    },
    changeTelAndMailData: function () {
      if (this.isFix.telAndMail) {
        this.$emit('form-change-tel-and-mail', {
          tel1: this.tel1,
          tel2: this.tel2,
          tel3: this.tel3,
          email: this.email
        })
        this.isDisabled.telAndMail = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .fade {
    &-enter-active, &-leave-active {
      will-change: opacity;
      transition: opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    }
    &-enter, &-leave-to {
      opacity: 0;
    }
  }
  .fontBlack {
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/forms/FormNameAndTelAndMail.vue